import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ContractorBaseAuction } from '../../home/models/contractor-base-auction';
import { DistributorType } from '../../home/models/distributor-type';
import { OtherKpFilter } from '../models/other-kp-filter';


@Injectable()
export class BusOtherKpFilterService {
  private messageFilter = new BehaviorSubject<OtherKpFilter>(new OtherKpFilter());
  private messageOtherKpNumber = new BehaviorSubject<string>('');
  private messageClearModalFilter = new BehaviorSubject<string>('');
  private messageClearSearchModalFields = new BehaviorSubject<string>('');
  private messageContractBaseOtherKp = new BehaviorSubject<ContractorBaseAuction>(new ContractorBaseAuction());

  private currentStateOtherKpFilter = new OtherKpFilter();

  currentFilter$ = this.messageFilter.asObservable();
  currentOtherKpNumber$ = this.messageOtherKpNumber.asObservable();
  currentClearModalFilter$ = this.messageClearModalFilter.asObservable();
  currentClearSearchModalFields$ = this.messageClearSearchModalFields.asObservable();
  currentContractBaseOtherKp$ = this.messageContractBaseOtherKp.asObservable();

  currentDistributorType = new DistributorType()

  constructor() { }

  changeFilter(filter: OtherKpFilter, isClear = false) {
    if (!isClear) {
      Object.keys(filter).forEach(key => {
        if (filter[key] != null) {
          this.currentStateOtherKpFilter[key] = filter[key];
        }
      });
    } else {
      Object.keys(filter).forEach(key => {
        if (filter[key] == null || filter[key].length === 0) {
          this.currentStateOtherKpFilter[key] = null;
        }
      });
    }

    this.messageFilter.next(this.currentStateOtherKpFilter);
  }

  changeOtherKpNumber(otherKpNumber: string) {
    this.messageOtherKpNumber.next(otherKpNumber);
  }

  changeClearModalFilter(key: string) {
    this.messageClearModalFilter.next(key);
  }

  changeClearSearchModalFields(key: string) {
    this.messageClearSearchModalFields.next(key);
  }

  changeContractBaseOtherKp(contractBaseOtherKp: ContractorBaseAuction) {
    this.messageContractBaseOtherKp.next(contractBaseOtherKp);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/services/bus-other-kp-filter.service.ts